import { formTypes, historyType } from "../types";

export const initialState: formTypes = {
  gross: "",
  grossForUnits: "",
  grossForSuperannuation: "",
  studyOrTrainingLoan: "no",
  netAmountPaid: "",
  unitsperday: "",
  rateperunit: "",
  superannuation: "",
  taxWithdeld: "",
  financialYear: "2025/26",
  taxFreeThresholdClaimed: "yes",
  payFreqArray: "weekly",
};

export const financialYearOptions = [
  { label: "2021/22", value: 10 },
  { label: "2022/23", value: 10 },
  { label: "2023/24", value: 10.5 },
  { label: "2024/25", value: 10.5 },
  { label: "2025/26", value: 10.5 },
];

export const payFreqArray = [
  // { label: 'Yearly', value: 'yearly' },
  // { label: 'Quarterly', value: 'quarterly' },
  { label: "Monthly", value: "monthly" },
  { label: "Fortnightly", value: "fortnightly" },
  { label: "Weekly", value: "weekly" },
];

export const usersField = [
  { label: "First Name", field: "firstName" },
  { label: "Last Name", field: "lastName" },
  { label: "Email", field: "email" },
  { label: "Subscription", field: "subscriptionStatus" },
  { label: "Action", field: "action" },
];

export const history: historyType = {
  history: undefined,
  location: null,
};
